import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react"; // Import Lucide icons

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    const { confirmPassword, ...registrationData } = formData; // Exclude confirmPassword

    const pathUrl =
      process.env.REACT_APP_BACKEND_URL || "http://localhost:8080/api";

    axios
      .post(pathUrl + "/auth/register", registrationData) // API call for registration
      .then((response) => {
        console.log("User registered:", response.data);
        alert("Registration successful! Please log in.");
        navigate("/login"); // Redirect to login page after successful registration
      })
      .catch((error) => {
        console.error("Registration failed:", error.response?.data || error);
        alert("Registration failed. Please try again.");
      });
  };

  return (
    <div className="container mt-5">
      <div className="card p-4">
        <h2 className="text-center">Register</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="firstName"
            placeholder="Enter your first name"
            className="form-control mb-3"
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Enter your last name"
            className="form-control mb-3"
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            className="form-control mb-3"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          {/* Password Field with Eye Icon */}
          <div className="input-group mb-3">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter your password"
              className="form-control"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
            <span
              className="input-group-text bg-transparent border-start-0"
              onClick={togglePasswordVisibility}
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                padding: "0.375rem 0.75rem",
                border: "0",
              }}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </span>
          </div>

          {/* Confirm Password Field with Eye Icon */}
          <div className="input-group mb-3">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm your password"
              className="form-control"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
            />
            <span
              className="input-group-text bg-transparent border-start-0"
              onClick={toggleConfirmPasswordVisibility}
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                padding: "0.375rem 0.75rem",
                border: "0",
              }}
            >
              {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </span>
          </div>

          <input
            type="submit"
            value="Register"
            className="btn btn-outline-success form-control rounded-0"
            style={{
              backgroundColor: '#010000',
              borderColor: '#010000',
              color: 'white'
            }}
          />
        </form>

        <p className="text-center mt-3">
          Already have an account? <a href="/login" style={{ color: '#010000' }}>Login</a>
        </p>
      </div>
    </div>
  );
};

export default Register;
